export const NO_OF_LIST_GRID = 4;
